import React, {useMemo} from "react";
import {Typography} from "antd";
import {useTranslation} from "react-i18next";
import {formatMomentDate} from "../../../../../utils/helpers";
import {StepDescriptionTypes} from "./StepTypes";

const {Text} = Typography;

const StepDescription = ({
    state,
    canceled,
    passed,
    startDate,
    endDate,
    mergedAt,
    deliveryCreatedAt,
    assignedCourier,
    renderProofIcon
}: StepDescriptionTypes) => {
    const {t} = useTranslation(["orderDetail"]);

    const startTime = useMemo(() => {
        if (state === "waiting") {
            return formatMomentDate(deliveryCreatedAt);
        } else if (startDate) {
            return formatMomentDate(startDate);
        } else {
            return "";
        }
    }, [state, deliveryCreatedAt, startDate]);

    const endTime = useMemo(() => {
        if (state === "onDeliveryAddress" && passed) {
            t("passed", {ns: "orderDetail"});
        } else if (endDate) {
            return formatMomentDate(endDate);
        } else {
            return "";
        }
    }, [state, passed, endDate]);

    const renderMergedAt = (
        <div key={Math.random()}>
            <Text type="warning">{t("mergedAt", {ns: "orderDetail"})}: </Text>
            {formatMomentDate(mergedAt)}
        </div>
    );

    const renderStartTime = useMemo(() => {
        return (
            <div key={Math.random()}>
                <Text style={{color: "#618C04", fontWeight: 600}}>
                    {t("fields.start", {ns: "common"})} :{" "}
                </Text>
                {startTime}
            </div>
        );
    }, [startTime, deliveryCreatedAt, startDate, state]);

    const renderEndTime = useMemo(() => {
        return (
            <div key={Math.random()}>
                <Text style={{color: "#CE0000", fontWeight: 600}}>
                    {" "}
                    {t("fields.end", {ns: "common"})}:{" "}
                </Text>
                {endTime}
            </div>
        );
    }, [endTime, deliveryCreatedAt, endDate, state]);

    const renderContent = () => {
        const renders = [];
        if (state === "onDeliveryAddress" && mergedAt) renders.push(renderMergedAt);
        if (startDate) renders.push(renderStartTime);
        if (endDate) {
            renders.push(renderEndTime);
            if (state === "onDeliveryAddress") {
                renders.push(
                    <div key={Math.random()}>
                        <Text type="warning">
                            {canceled
                                ? t("stepInfo.canceled", {ns: "orderDetail"})
                                : passed
                                ? t("stepInfo.passed", {ns: "orderDetail"})
                                : t("stepInfo.productsDelivered", {
                                      ns: "orderDetail",
                                      courierName: assignedCourier
                                  })}
                        </Text>
                        {renderProofIcon()}
                    </div>
                );
            }
        } else if (state === "onPickUpAddress") {
            renders.push(
                <div key={Math.random()}>
                    <Text type="warning">
                        {canceled
                            ? t("stepInfo.canceled", {ns: "orderDetail"})
                            : passed
                            ? t("stepInfo.passed", {ns: "orderDetail"})
                            : endDate &&
                              t("stepInfo.productsReveived", {
                                  ns: "orderDetail",
                                  courierName: assignedCourier
                              })}
                    </Text>
                    {renderProofIcon()}
                </div>
            );
        }
        return <>{renders}</>;
    };

    return <div style={{marginBottom: "20px"}}>{renderContent()}</div>;
};

export default StepDescription;
